// @flow
import React from 'react';

import {
  ESTIMATE_COMMIT_SUMMARY_DSP,
  ESTIMATE_COMMIT_SUMMARY_NON_DSP,
  ESTIMATE_COMMIT_SUMMARY_TOTAL_OVERALL,
} from '../../../constants';
import { StyledFlexItem, StyledFlexRow } from '../../../common-utils/styledComponents';

import { CommitSummaryTable } from './CommitSummaryTable';

// Fixed height shared by the side-by-side non-DSP/DSP cards so they line up evenly.
// Tall enough that neither card needs to scroll in the common case.
const SIDE_BY_SIDE_CARD_HEIGHT = '700px';

export const DspCommitSummaryLayout = ({
  commitSummary,
  commitSummaryDsp,
  totalOverallCommits,
}) => {
  return (
    <>
      <StyledFlexRow>
        <StyledFlexItem>
          <CommitSummaryTable
            height={SIDE_BY_SIDE_CARD_HEIGHT}
            inputDataSource={commitSummary}
            label={ESTIMATE_COMMIT_SUMMARY_NON_DSP}
            width="100%"
          />
        </StyledFlexItem>
        <StyledFlexItem>
          <CommitSummaryTable
            height={SIDE_BY_SIDE_CARD_HEIGHT}
            inputDataSource={commitSummaryDsp}
            label={ESTIMATE_COMMIT_SUMMARY_DSP}
            width="100%"
          />
        </StyledFlexItem>
      </StyledFlexRow>
      <CommitSummaryTable
        inputDataSource={totalOverallCommits}
        label={ESTIMATE_COMMIT_SUMMARY_TOTAL_OVERALL}
        width="100%"
      />
    </>
  );
};
